import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { membershipPlans } from "./membershipPlans";
import { allPlans, subscriptionPlans } from "./subscribtionPlans";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  if (!date) {
    return;
  }
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Intl.DateTimeFormat("en-IN", options).format(new Date(date));
};

export const reformatTime = (originalDate) => {
  const dateParts = originalDate.split("-"); // Split the date string by '-'
  return `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`; // Rearrange the parts
};

export const extractAmount = (str) => {
  let match = str.match(/\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : null;
};

export const GST = (price) => {
  const gst = price * 0.18;
  return Number(gst.toFixed(2));
};

export const GATEWAY_FEE = (amount) => {
  const price = extractAmount(amount);
  const fixedFee = 0.5;
  const fee = price * 0.02 + fixedFee;
  return Number(fee.toFixed(2));
};

export const GST_FEE = (amount) => {
  const gst = amount * 0.18;
  return Number(gst.toFixed(2));
};

export const PLATFORM_FEE = (amount) => {
  const fee = amount * 0.02;
  return Number(fee.toFixed(2));
};

// export const calculateAge = (dob) => {
//   const birthDate = new Date(dob);
//   const today = new Date();
//   let age = today.getFullYear() - birthDate.getFullYear();
//   const m = today.getMonth() - birthDate.getMonth();
//   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
//     age--;
//   }
//   return age;
// };

export const TotalAmount = (amount) => {
  const total = GST_FEE(amount) + PLATFORM_FEE(amount) + Number(amount);
  return Math.floor(total.toFixed(2));
};

export const findCurrentPlan = (name) => {
  if (!name) return null;
  return membershipPlans.find(
    (plan) => plan.title.toLowerCase() === name.toLowerCase()
  );
};

export const findPlan = (planId) => {
  const plan = subscriptionPlans.find((plan) => plan.id === Number(planId));

  return plan;
};

export const getUpgradablePlans = (plan, amount) => {
  const currentPrice = Number(amount);
  const currentTitle = plan;

  if (isNaN(currentPrice)) return [];

  return membershipPlans.filter(
    (plan) => plan.title !== currentTitle && plan.price > currentPrice
  );
};

export const validtill = (started, plan) => {
  const date = new Date(started);
  const currentDate = date.getDate();
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();

  if (plan === "Star Membership") {
    const validTill = new Date(currentYear + 1, currentMonth, currentDate);
    return validTill.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } else if (plan === "Gold Membership") {
    const validTill = new Date(currentYear + 5, currentMonth, currentDate);
    return validTill.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } else if (plan === "Platinum Membership") {
    return "Life-Time";
  }
};

export const greetUser = () => {
  const currentHour = new Date().getHours();

  let greeting;

  if (currentHour >= 5 && currentHour < 12) {
    greeting = "Good Morning";
  } else if (currentHour >= 12 && currentHour < 17) {
    greeting = "Good Afternoon";
  } else {
    greeting = "Good Evening";
  }

  return greeting;
};

export const adjustedPrice = (
  basePrice,
  newPrice
) => {
    const diff = Math.round((newPrice - basePrice) * 100) / 100;

    return diff < 0 ? 0 : diff;
};

export const findHealthPlan = (id) => {
  const plan = [].find((plan) => plan.id === +id);

  return plan;
};

export const formatedDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatTime = (timeString) => {
  return new Date(timeString).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const calculateDiscount = (price, offPrice) => {
  return price - offPrice;
};

export const getDuration = (plan) => {
  if(plan.toLowerCase() === "star membership") return 3;
  if(plan.toLowerCase() === "gold membership") return 3;
  if(plan.toLowerCase() === "platinum membership") return 12;
}

export const getTitle = (duration, member) => {
  return subscriptionPlans.find(
    (sub) => sub.duration === duration && sub.members === member,
  )?.title;
};

export const calculateAge = (dob) => {
  if (!dob) return null;

  const [year, month, day] = dob.split("-").map(Number);

  if (!year || !month || !day) return null;

  const today = new Date();

  let age = today.getFullYear() - year;

  const birthdayPassed =
    today.getMonth() + 1 > month ||
    (today.getMonth() + 1 === month && today.getDate() >= day);

  if (!birthdayPassed) {
    age--;
  }

  return age;
};